import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/axiosConfig';
import { useAuth } from './AuthContext'; // Import your existing AuthContext

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const { isAuthenticated, user } = useAuth();
    const [cartData, setCartData] = useState({ totalAmount: 0, totalItems: 0, items: [] });
    const [isLoading, setIsLoading] = useState(false);

    // Use useCallback to memoize the function, preventing infinite loops in useEffects
    const fetchCartData = useCallback(async () => {
        if (!isAuthenticated) {
            setCartData({ totalAmount: 0, totalItems: 0, items: [] });
            return;
        }

        try {
            const response = await api.get('/cart/');

            if (response.data.success) {
                setCartData({
                    totalItems: response.data.totalItems || 0,
                    totalAmount: response.data.grandTotal || 0,
                    items: response.data.items || [],
                });
            } else {
                setCartData({ totalItems: 0, totalAmount: 0, items: [] });
            }
        } catch (error) {
            console.error("Cart fetch error", error);
            setCartData({ totalItems: 0, totalAmount: 0, items: [] });
        }
    }, [isAuthenticated]);
    // Dependency array remains correct
    const addToCart = async (product) => {
        // Optimistic update: update cart immediately
        // setCartData(prev => ({
        //     ...prev,
        //     totalItems: prev.totalItems + 1,
        //     totalAmount: prev.totalAmount + (product.price || 0),
        //     items: [...prev.items, product],
        // }));

        try {
            // Send request to backend
            await api.post('/cart/add', { productId: product.id, quantity: 1 });
            // Fetch cart from backend to ensure sync
            await fetchCartData();
        } catch (error) {
            console.error('[CartContext] Error adding to cart:', error);
            // fetchCartData(); // rollback if needed
        }
    };
    const removeFromCart = async (productId) => {
        try {
            await api.delete('/cart/remove', { data: { productId } });
            fetchCartData(); // Update cart
        } catch (error) {
            console.error('[CartContext] Error removing from cart:', error);
        }
    };

    // Fetch cart data whenever authentication status changes
    useEffect(() => {
        fetchCartData();
    }, [isAuthenticated, fetchCartData]);

    const value = {
        cartData,
        isLoading,
        fetchCartData, // This function is crucial for other components to trigger an update!
        setCartData,
        addToCart,
        removeFromCart,
    };

    return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};